<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == 'agro-fenologia') {
            next({ name: 'agro-fenologia-list' });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == 'agro-fenologia') {
            this.$router.push({ name: 'agro-fenologia-list' });
        }
    },
};
</script>
